import { createPostEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type PostOverrideAdminFeatureFlagByCustomerIdRequest = {
	customerId: number,
	customerName: string,
	enabled: boolean,
	featureFlag: string,
	shardName?: string;
};

export const postOverrideAdminFeatureFlagByCustomerId =
	createPostEndpoint<PostOverrideAdminFeatureFlagByCustomerIdRequest, void>(
		(request) =>
			`/api/v3/core/feature-flags/${request.featureFlag}/customers/${request.customerId}/override-default`, {
			headers: (request) => {
				if (request?.shardName) {
					return { [ HttpHeader.Shard ]: request.shardName };
				}

				return {};
			},
			requestTransform: ({ customerId, featureFlag, shardName, ...rest }) => rest,
			skipAuthRefresh: true
		}
	);
